export default "__VITE_PUBLIC_ASSET__bac27e97__"